import { Alert, Button, Form } from 'antd';
import { useState } from 'react';
import { BookyPageTitle } from '../../Components/Layout/BookyTitle';
import { useNavigate, useSearchParams } from "react-router-dom";
import PageSmall from '../../Components/Page/PageSmall';
import BookyBox from '../../Components/Layout/BookyBox';
import { BookyInput } from '../../Components/Forms/BookyInput';
import { TextService } from '../../Services/TextService';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';
import { UserService } from '../../Services/UserService';

const CompleteExternalRegistration = () => {
    const navigation = useNavigate();
    const [searchParams] = useSearchParams();
    const [errorText, setErrorText] = useState("");
    const [loading, setLoading] = useState(false);
    const GetText = TextService.GetText;

    // After completing the profile, go to premium flow or dashboard
    const subscription = searchParams.get("subscription");
    const token = searchParams.get("token");
    const tokenExpires = searchParams.get("tokenExpires");
    const mfa = searchParams.get("mfa");

    const onSubmit = async (formValues: any) => {
        setLoading(true);
        const result = await UserService.CompleteExternalRegistration(formValues.companyname);
        setLoading(false);

        if (!result.success) {
            setErrorText(result.message ?? "Something went wrong.");
            return;
        }

        if (subscription && token) {
            const lang = getCurrentLanguage();
            navigation(`/${lang}/finalizepremiumregistration?token=${token}&tokenExpires=${tokenExpires}&subscription=${subscription}${mfa ? `&mfa=${mfa}` : ''}`);
        } else {
            navigation("/" + getCurrentLanguage() + "/NewUserCreatedWithProvider");
        }
    };

    return <PageSmall pageTitle={GetText("CompleteExternalRegistration_Title")} noIndex={true}>
        <BookyBox>
            <BookyPageTitle text={GetText("CompleteExternalRegistration_Title")} subText={GetText("CompleteExternalRegistration_Description")} />
            <Form
                onFinish={onSubmit}
                layout="vertical"
                autoComplete="off"
            >
                <BookyInput
                    label={GetText("CompleteExternalRegistration_CompanyName")}
                    name="companyname"
                    requiredMessage={GetText("CompleteExternalRegistration_CompanyName_Validation")}
                />
                {errorText && <Alert type="warning" showIcon message={errorText} style={{ marginBottom: "16px" }} />}
                <Form.Item>
                    <Button
                        loading={loading}
                        style={{ width: "100%" }}
                        size="large"
                        type="primary"
                        htmlType="submit"
                    >
                        {GetText("CompleteExternalRegistration_Submit")}
                    </Button>
                </Form.Item>
            </Form>
        </BookyBox>
    </PageSmall>;
};

export default CompleteExternalRegistration;
